// extracted by mini-css-extract-plugin
export default {"wrapper":"WorkspaceSuperappErrorPage__wrapper--1g3TX","icon":"WorkspaceSuperappErrorPage__icon--1sW-F"};